import React, { useEffect } from "react";
import Detail from "./Detail";
import { fetchArticle } from "../../../states/actions/fetchArticle";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "../../common/LoadingScreen";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import paths from "../../../constants/paths";
import Breadcrumb from "../../common/BreadCrumb";

const Article = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchArticle.content);
  const isLoading = useSelector((state) => state.fetchArticle.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );

  const { article } = data;

  useEffect(() => {
    dispatch(fetchArticle(id));
  }, [id, dispatch]);

  useDocumentTitle(data.page_title);

  const openCalendlyPopup = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/ukvisajobs-support/15-mins?hide_gdpr_banner=1",
      });
    } else {
      console.error("Calendly script not loaded");
    }
  };
  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    {
      name: article?.title,
      link: `${paths.SITE_BASE_URL}/article/${article?.encoded_id}/${article?.slug}`,
    },
  ];
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="dash">
            <Breadcrumb items={breadcrumbItems} />
            <div className="contain-fluid">
              <Detail article={article} />
              {article?.calendly_btn_required === "1" && (
                <div className="calendly_btn">
                  <button onClick={openCalendlyPopup} className="site_btn">
                    Schedule time with me
                  </button>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Article;
